<div class="modal-header">
    <h4 class="modal-title">Confirmation Message</h4>
</div>
<div class="modal-body">
    <dx-form [formData]="message">
        <dxi-item dataField="name" [label]="{ text: 'Title' }"></dxi-item>
        <dxi-item dataField="isDefaultMessage" [label]="{ text: 'Default Message' }" editorType="dxCheckBox"></dxi-item>
        <dxi-item dataField="isChannelPartnerMessage" [label]="{ text: 'Channel Partner Message' }" editorType="dxCheckBox"></dxi-item>
        <dxi-item dataField="isNoPrePayMessage" [label]="{ text: 'No PrePay Message' }" editorType="dxCheckBox"></dxi-item>
        <dxi-item [label]="{ text: 'Message' }">
            <div *dxTemplate>
                <dx-text-area [(value)]="message.message" [height]="400"> </dx-text-area>
            </div>
        </dxi-item>
        <dxi-item [label]="{ text: 'Message 2' }">
            <div *dxTemplate>
                <dx-text-area [(value)]="message.message2" [height]="400"> </dx-text-area>
            </div>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" (click)="save()">Save</button>
    <button class="btn btn-light" (click)="close()">Cancel</button>
</div>
